import { some } from 'lodash';
import queryString from 'query-string';

const alphaNumericRegex = /^[0-9a-z?]+$/;
const nwAppDeepLinkRegex = /^nerdwallet-app:\/\/open\//;

export const isRelativeUri = function isRelativeUri(uri) {
  if (!uri.length) return false;

  let isAlphaNumeric = false;
  try {
    isAlphaNumeric = alphaNumericRegex.test(uri[1]);
  } catch (e) {
    isAlphaNumeric = false;
  }

  if (uri[0] === '/' && isAlphaNumeric) {
    return true;
  }

  return false;
};

/**
 *
 * @param {string} uri string redirect uri
 * @returns {boolean} - whether or not the redirect uri begins with allowed nerdwallet domains
 */
export const isAllowedNerdWalletDomain = (uri) =>
  some(
    [
      /^https:\/\/(www\.|localnerd\.)?nerdwallet\.com\//,
      /^https:\/\/(.*\.vercel\.|localnerd\.)?stage\.nerdwallet\.biz\//,
      /^nerdwallet-app:\/\/open\//,
    ],
    (regex) => regex.test(uri),
  );

/**
 *
 * @param {string} uri
 * @returns {boolean} true if the URI is a NW App deep link, false otherwise
 */
export const isAllowedNerdWalletAppDeepLink = (uri) => {
  return nwAppDeepLinkRegex.test(uri);
};

export const getQueryRedirect = (location) => {
  const query = queryString.parse(location?.search);

  // queryString.parse always returns an object
  if (
    query.redirect_uri &&
    (isRelativeUri(query.redirect_uri) ||
      isAllowedNerdWalletDomain(query.redirect_uri))
  ) {
    return query.redirect_uri;
  }

  return null;
};

export const redirectToNerdWalletPage = function redirectToNerdWalletPage(uri) {
  const redirectUri =
    isRelativeUri(uri) || isAllowedNerdWalletDomain(uri) ? uri : '/home';

  if (typeof window !== 'undefined') {
    window.location = redirectUri;
  }
};
